// Leva o cliente até a tabela de medidas dentro da descrição e o traz de
// volta ao seletor de tamanho, para ele não perder o lugar onde estava.
(() => {
  const link = document.querySelector('[data-ir-medidas]');
  if (!link) return;

  link.addEventListener('click', () => {
    const descricao = document.querySelector('.product__description');
    const alvo = descricao?.querySelector('img') || descricao;
    if (!alvo) return;

    alvo.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
})();
